import React, {Component} from "react";
import propTypes from "prop-types";
import _ from "lodash";

const PropTypes = {
	isFetching: propTypes.bool,
	filter: propTypes.string.isRequired,
	filterChange: propTypes.func.isRequired,
	modality: propTypes.string.isRequired,
	entity: propTypes.string.isRequired,
	agencies: propTypes.object.isRequired,
	municipalityFilter: propTypes.func.isRequired,
	municipalityChange: propTypes.func.isRequired,
	stateChange: propTypes.func.isRequired,
	agenciable: propTypes.object.isRequired
}

class ProjectNavigation extends Component {
	render() {
		let {filter, modality, entity, isFetching, agenciable} = this.props;
		let states = this.stateList();
		let municipalities = this.municipalityList();
		return (<div className="subnavigation">
			<div className="field has-addons">
				<div className="control">
					<label htmlFor="psn-projects" className="label is-small">Navegación por</label>
					<div className={`select is-small is-dark${isFetching ? ' is-loading': ''}`}>
						<select id="psn-projects" value={filter} onChange={(e) => this.props.filterChange(e)}>
							<option disabled>--- Tipo de proyecto ---</option>
							<option value="all_projects" defaultValue>Todas las instancias</option>
							<option value="registred" >Proyectos registrados</option>
							<option value="code" >Proyectos con folio</option>
							<option value="benefited" >Proyectos beneficiados</option>
						</select>
					</div>
				</div>

				{(modality !== 'modalidad-ii') &&
				<div className="control">
					<label htmlFor="psn-states" className="label is-small">Estado</label>
					<div className={`select is-small is-dark${isFetching ? ' is-loading': ''}`}>
						<select id="psn-state" onChange={(e) => this.props.stateChange(e.target.value)} value={entity ? entity : undefined}>
							<option disabled defaultValue>--- Estados ---</option>
							{_.map(states,(st, k) => {
								return <option value={st.agenciable_short} key={k}>{st.agenciable_name}</option>
							})}
						</select>
					</div>
				</div>}

				{(modality === 'modalidad-ii') &&
				<div className="control">
					<label htmlFor="psn-states" className="label is-small">Estado</label>
					<div className={`select is-small is-dark${isFetching ? ' is-loading' : ''}`}>
						<select id="psn-states" onChange={(e) => this.props.municipalityFilter(e.target.value)} value={agenciable.state}>
							<option disabled defaultValue>--- Estados ---</option>
							{_.map(states,(mn, j) => {
								return <option value={mn.agenciable_state_short} key={j}>{mn.agenciable_state_name}</option>
							})}
						</select>
					</div>
				</div>}

				{(modality === 'modalidad-ii') &&
				<div className="control">
					<label htmlFor="psn-mun" className="label is-small">Municipio</label>
					<div className={`select is-small is-dark ${isFetching && 'is-loading'}`}>
						<select id="psn-mun" onChange={(e) => this.props.municipalityChange(e.target.value)} value={agenciable.municipality ? agenciable.municipality : undefined}>
							<option defaultValue>--- Municipios ---</option>
							{_.map(municipalities, (mn, j) => {
								return <option value={mn.agenciable_slug} key={j}>{mn.agenciable_name}</option>
							})}
						</select>
					</div>
				</div>}
			</div>
		</div>);
	}

	stateList(){
		const {modality, agencies, filter} = this.props;

		switch (filter) {
			case 'registred':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_id}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_id}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			case 'code':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_code}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_code}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			case 'benefited':
				if(modality !== 'modalidad-ii'){
					return _.sortBy(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}), ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}),'agenciable_state_id'), ['agenciable_state_name']);
				}
			default :
				if(modality !== 'modalidad-ii'){
					return _.sortBy(agencies[modality], ['agenciable_name']);
				}else {
					return _.sortBy(_.uniqBy(agencies[modality],'agenciable_state_id'), ['agenciable_state_name']);
				}
		}
	}

	municipalityList(){
		const {agencies, modality, filter, agenciable} = this.props;

		switch (filter) {
			case 'registred':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_id}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			case 'code':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_code}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			case 'benefited':
				return _.sortBy(_.filter(_.filter(agencies[modality], (o) => {return o.project_benefited === 1}), {agenciable_state_short: agenciable.state}), ['agenciable_name'])
			default :
				return _.sortBy(_.filter(agencies[modality], {agenciable_state_short: agenciable.state}), ['agenciable_name'])
		}
	}
}

ProjectNavigation.propTypes = PropTypes;

export default ProjectNavigation;


// WEBPACK FOOTER //
// ./src/elements/navigation/project-navigation.jsx